"use client";

import { useState } from "react";
import { X, ZoomIn, ChevronLeft, ChevronRight } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogClose } from "@/components/ui/dialog";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryImages = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/luxury_hotel_suite.png",
  alt: "Luxury Hotel Suite Interior",
  label: "Hotels"
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/airplane_cabin_view.png",
  alt: "Modern Airplane Cabin",
  label: "Flights"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/airport_transfer_taxi.png",
  alt: "Premium Airport Taxi Service",
  label: "Transfers"
}, {
  id: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/tropical_resort_pool.png",
  alt: "Tropical Resort Swimming Pool",
  label: "Resorts"
}, {
  id: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/car_rental_fleet.png",
  alt: "Modern Car Rental Fleet",
  label: "Car Rental"
}, {
  id: 6,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/mountain_cabin_stay.png",
  alt: "Cozy Mountain Cabin",
  label: "Accommodations"
}, {
  id: 7,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/city_skyline_view.png",
  alt: "Urban City Skyline View",
  label: "City Breaks"
}, {
  id: 8,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/beachfront_villa.png",
  alt: "Private Beachfront Villa",
  label: "Villas"
}, {
  id: 9,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/business_class_lounge.png",
  alt: "Exclusive Airport Lounge",
  label: "Business Travel"
}, {
  id: 10,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/scenic_train_journey.png",
  alt: "Scenic Train Travel Experience",
  label: "Excursions"
}, {
  id: 11,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/boutique_hotel_lobby.png",
  alt: "Elegant Boutique Hotel Lobby",
  label: "Boutique Stays"
}, {
  id: 12,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/safari_lodge_view.png",
  alt: "African Safari Lodge",
  label: "Adventure"
}];
export default function Gallery() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const openLightbox = (index: number) => {
    setActiveIndex(index);
    setLightboxOpen(true);
  };
  const goPrev = () => {
    setActiveIndex(prev => (prev - 1 + galleryImages.length) % galleryImages.length);
  };
  const goNext = () => {
    setActiveIndex(prev => (prev + 1) % galleryImages.length);
  };
  return;
}